export enum PersonalSettingsView {
  DASHBOARD = 1,
  LOGIN = 2,
  QUALIFICATIONS = 3,
  CARDS = 4,
  DONATIONS = 5,
  TRANSFERS = 6,
  CONNECTED_ACCOUNTS = 7,
}
